import styles from './SkipToContent.module.css'

const SkipToContent = () => {
  return (
    <a href="#main-content" className={styles.skipLink}>
      Spring naar hoofdinhoud
    </a>
  )
}

export default SkipToContent
